import React from "react";
import { Link } from "react-router-dom";
import { formatChildAgeLabel } from "helpers/jackrabbit/programAgeBounds";

const ProgramAgeGuidance = ({
  programName,
  ageMismatch,
  variant = "inline",
}) => {
  if (!ageMismatch) return null;

  const {
    ageRangeLabel,
    suggestedProgramLabel,
    suggestedProgramUrl,
    childAgeYears,
    childAgeMonths,
  } = ageMismatch;

  const childLabel = formatChildAgeLabel(childAgeYears, childAgeMonths);
  const programLabel =
    programName === "Tumbling" ? programName : `${programName} classes`;

  if (variant === "empty") {
    return (
      <>
        <p className="programs-empty-schedule__message">
          {programLabel} are for {ageRangeLabel}. {childLabel.charAt(0).toUpperCase()}
          {childLabel.slice(1)} is outside that range.
        </p>
        <p className="programs-empty-schedule__hint">
          Browse the {suggestedProgramLabel} schedule with the same age already
          selected.
        </p>
      </>
    );
  }

  return (
    <p className="class-schedule-filter__age-guidance" role="status">
      {programLabel} are for {ageRangeLabel}. For {childLabel}, view{" "}
      <Link to={suggestedProgramUrl} className="class-schedule-filter__age-guidance-link">
        {suggestedProgramLabel}
      </Link>
      .
    </p>
  );
};

export default ProgramAgeGuidance;
